import request from './request';

const BASE = 'dashboard/admin/notifications';

const notificationService = {
  // User/dashboard profile (e.g. notification drawer)
  getStatistics: () =>
    request.get('dashboard/user/profile/notifications-statistic'),
  readAll: () => request.post('dashboard/notifications/read-all'),
  readAt: (id) => request.post(`dashboard/notifications/${id}/read-at`),

  // Admin panel – list with pagination
  getAll: (params = {}) =>
    request.get(BASE, { params }),

  // Send global push (global admin only; 403 otherwise)
  sendGlobal: (data) =>
    request.post(`${BASE}/send-global`, data),

  // Create notification record (no FCM send)
  create: (data) => request.post(BASE, data),

  getById: (id) => request.get(`${BASE}/${id}`),

  update: (id, data) => request.put(`${BASE}/${id}`, data),

  delete: (id) => request.delete(`${BASE}/${id}`),

  deleteBulk: (ids) =>
    request.delete(`${BASE}/delete`, { data: { ids } }),

  dropAll: () => request.get(`${BASE}/drop/all`),

  // Admin bell inbox — new endpoints backed by AdminNotification.
  bellList: (params = {}) => request.get(`${BASE}`, { params }),
  bellUnreadCount: () => request.get(`${BASE}/unread-count`),
  bellMarkRead: (id) => request.put(`${BASE}/${id}/read`),
  bellMarkAllRead: () => request.put(`${BASE}/read-all`),
};

export default notificationService;
